import { topBarMessages } from "@/mocks/navigation";

export default function TopBar() {
  const loop = [...topBarMessages, ...topBarMessages, ...topBarMessages, ...topBarMessages];

  return (
    <div className="w-full bg-primary-700 text-background-50">
      <div className="relative overflow-hidden py-2">
        <div className="ab-marquee">
          {loop.map((message, index) => (
            <span
              key={`${message}-${index}`}
              className="flex items-center gap-3 whitespace-nowrap px-6 text-[11px] uppercase tracking-[0.18em] md:text-xs"
            >
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-leaf-line text-[11px] text-secondary-300" />
              </span>
              {message}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}